<template>
	<div class="person-item" :class="{ 'choose-item': tag == 'choose' }" @click.prevent="toggleCheckbox()">
		<div class="checkbox-container" v-if="tag != 'choose'">
			<el-checkbox v-if="multiple" :disabled="disabled" v-model="item.checked">
			</el-checkbox>
			<el-radio v-else :model-value="checked" :label="item.departCode">
			</el-radio>
		</div>
		<div v-else>
			<img v-if="isDeleteShow" class="delete_img" src="../img/btn_detach.png" @click.stop="emit('delete', { item })" />
		</div>
		<div class="person-info">
			<div class="name">
				<custom-tooltip :pointer-flag="tag != 'choose'" :index="`${tag}${index}`" :content="`${item.departName}-${item.departCode}`" />
			</div>
			<div class="dept_name m-t-8" v-if="item.departType">
				<custom-tooltip :pointer-flag="tag != 'choose'" :index="`${tag}dept${index}`" :content="item.departType" />
			</div>
		</div>

	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import customTooltip from "../../../custom-tooltip/src/main.vue"; // 假设 CustomTooltip 是自定义的 tooltip 组件
const props = defineProps({
		tag: {
			type: String,
			default: "",
		},
		item: {
			type: Object,
			required: true
		},
		checked: {
			type: [String, Boolean],
			default: false,
		},
		index: {
			type: Number,
			required: true
		},
		multiple: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isDeleteShow: {
			type: Boolean,
			default: false,
		},
})
const checked1 = ref<boolean | string>(props.checked)
const emit = defineEmits(["dept-change",'delete']);

const toggleCheckbox= () =>{
	if (props.multiple) {
		if (props.disabled) return
		emit('dept-change', { item: { ...props.item, checked: props.item.checked }, checked: !props.item.checked, operate: props.tag, index: props.index })
	} else {
		checked1.value = props.item.departCode;
		// Emit an event to the parent component with the department object and its checked status
		emit('dept-change', { item: props.item, checked: checked1.value });
	}

}

</script>